import { INTERNAL_MEMBERSHIP } from '../actionTypes';

const initialState = {
  selectedUser: {},
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INTERNAL_MEMBERSHIP.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case INTERNAL_MEMBERSHIP.SELECTED:
      return {
        ...state,
        selectedUser: action.payload,
      };
    default:
      return state;
  }
};
